export default __webpack_public_path__ + "ab13ac4e089fd5e792f22a8a3685faf8.svg";